import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { profilesEndpoint } from "../constants";
import { useUser } from "../context/UserContext";
import linkaLogo from "../assets/AIAURA linka horizontal.png";


const Sidebar = ({ onLogout }) => { // Add onLogout prop
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const location = useLocation();
  const token = localStorage.getItem("token")

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch(profilesEndpoint+"me/", {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          }
        } );
        const data = await response.json();
        setAccountType(data.account_type);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const checkIfMobile = () => {
      const isMobileView = window.innerWidth < 768;
      setIsMobile(isMobileView);
      setIsOpen(!isMobileView);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onLogout) {
      onLogout();
    }
  };

  const menuItems = {
    recruiter: [
      {
        title: "Dashboard",
        path: "/dashboard",
        icon: "https://static.codia.ai/image/2025-03-15/71e3b14d-fff7-4147-95ec-52eb8fafce0f.svg",
      },
      {
        title: "Management",
        links: [
          {
            path: "/jobs",
            label: "Jobs",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
          {
            path: "/interviews",
            label: "Interview",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
                    {
            path: "/candidates",
            label: "Candidates",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
                          {
            path: "/clients_overview",
            label: "Client Dashboard",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
                          {
            path: "external_guide",
            label: "Client API Guide",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
          {
            path: "/offer_list",
            label: "Offer list",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },

        ],
      },
      {
        title: "Tools",
        links: [
          {
            path: "/calendar",
            label: "Calendar",
            icon: "https://static.codia.ai/image/2025-03-15/6b67655f-6494-454a-8869-5923a09823f4.svg",
          },
          {
            path: "/ai_analysis",
            label: "AI Analysis",
            icon: "https://static.codia.ai/image/2025-03-15/46492641-16fb-4b59-8d16-65e88b3cc64e.svg",
          },
   {
            path: "/HiringPipeline",
            label: "Hiring Pipeline",
            icon: "https://static.codia.ai/image/2025-03-15/46492641-16fb-4b59-8d16-65e88b3cc64e.svg",
          },
        ],
      },
      {
        title: "Chat",
        links: [
          {
            path: "/chat",
            label: "Team Chat",
            icon: "https://static.codia.ai/image/2025-03-15/5a246e2f-2d76-40ce-aa2e-dff4acb53c79.svg",
          },
          {
            path: "/candidate_chat",
            label: "Candidate Chat",
          },
          {
            path: "/candidate_emails",
            label: "Candidate Emails",
          },

        ],
      },

    ],
    client: [
      {
        title: "Dashboard",
        path: "/recruitment_manager/dashboard",
        icon: "https://static.codia.ai/image/2025-03-15/71e3b14d-fff7-4147-95ec-52eb8fafce0f.svg",
      },
      {
        title: "Management",
        links: [
          {
            path: "/recruitment_manager/candidates",
            label: "Candidates",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
          {
            path: "/recruitment_manager/recruiters",
            label: "Recruiters",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
          {
            path: "/recruitment_manager/jobs",
            label: "Jobs",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
         {
            path: "/CreateCandidate",
            label: "Create Candidate",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
                    {
            path: "/recruitment_manager/users",
            label: "Users",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
          {
            path: "/cvsearch",
            label: "CV Search",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
        ],
      },
      {
        title: "Tools",
        links: [
          {
            path: "/recruitment_manager/report",
            label: "Reports",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
          {
            path: "/recruitment_manager/ai_analysis",
            label: "AI Insights",
            icon: "https://static.codia.ai/image/2025-03-15/46492641-16fb-4b59-8d16-65e88b3cc64e.svg",
          },
          {
            path: "/recruitment_manager/calendar",
            label: "Calendar",
            icon: "https://static.codia.ai/image/2025-03-15/6b67655f-6494-454a-8869-5923a09823f4.svg",
          },
        ],
      },
      {
        title: "Chat",
        path: "/recruitment_manager/chat",
        icon: "https://static.codia.ai/image/2025-03-15/5a246e2f-2d76-40ce-aa2e-dff4acb53c79.svg",
      },

    ],
    candidate: [
      {
        title: "Dashboard",
        path: "/candidate/dashboard",
        icon: "https://static.codia.ai/image/2025-03-15/71e3b14d-fff7-4147-95ec-52eb8fafce0f.svg",
      },
      {
        title: "Jobs",
        links: [
          {
            path: "/candidate/jobs",
            label: "Jobs",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
          {
            path: "/user_offer_list",
            label: "My offers",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
          {
            path: "/candidate/applications",
            label: "Applications",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
        ],
      },
      {
        title: "Tools",
        links: [
          {
            path: "/candidate/calendar",
            label: "Calendar",
            icon: "https://static.codia.ai/image/2025-03-15/6b67655f-6494-454a-8869-5923a09823f4.svg",
          },
          {
            path: "/candidate/company-profiles",
            label: "Company  Profiles",
            icon: "https://static.codia.ai/image/2025-03-15/46492641-16fb-4b59-8d16-65e88b3cc64e.svg",
          },
        ],
      },
      {
        title: "Chat",
        path: "/candidate/chat",
        icon: "https://static.codia.ai/image/2025-03-15/5a246e2f-2d76-40ce-aa2e-dff4acb53c79.svg",
      }
    ],  clientella: [
                             {
            path:"/performance",
            label: "dashboard",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
         {
            path: "/jobs",
            label: "Jobs",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
   {
            path: "/HiringPipeline",
            label: "Hiring Pipeline",
            icon: "https://static.codia.ai/image/2025-03-15/46492641-16fb-4b59-8d16-65e88b3cc64e.svg",
          },      
          {
            path: "/calendar",
            label: "Calendar",
            icon: "https://static.codia.ai/image/2025-03-15/6b67655f-6494-454a-8869-5923a09823f4.svg",
          },
                    {
            path: "/ai_analysis",
            label: "AI Analysis",
            icon: "https://static.codia.ai/image/2025-03-15/46492641-16fb-4b59-8d16-65e88b3cc64e.svg",
          },
          {
            path: "/chat",
            label: "Team Chat",
            icon: "https://static.codia.ai/image/2025-03-15/5a246e2f-2d76-40ce-aa2e-dff4acb53c79.svg",
          },
    ], linka: [
               {
            path: "/candidates",
            label: "Candidates",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
         {
            path: "/jobs",
            label: "Jobs",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },
                   {
            path: "/settings",
            label: "Settings",
            icon: "https://static.codia.ai/image/2025-03-15/0754e61e-3cab-4cd9-beea-60d47dd0d1ab.svg",
          },  
                          {
            path: "/shared_candidates",
            label: "Shared Candidates",
            icon: "https://static.codia.ai/image/2025-03-15/732cba35-3dd2-42de-bb34-d8c2dd35c629.svg",
          },
    ],
  };



  const MenuItem = ({ item }) => {
    // If this is the logout button (support), render as a button instead of Link
    if (item.isLogout) {
      return (
        <button
          onClick={handleLogout}
          className={`flex items-center w-full px-3 py-2 rounded-lg transition-all duration-200 hover:bg-gray-100 text-[#414651]`}
        >
          <div className="flex items-center gap-3 w-full">
            <div className="w-5 h-5 flex-shrink-0">
              {item.icon && (
                <img src={item.icon} alt="" className="w-full h-full" />
              )}
            </div>
            <span
              className={`font-semibold ${
                isOpen ? "opacity-100" : "opacity-0 md:opacity-100"
              } transition-opacity duration-200`}
            >
              {item.label || item.title}
            </span>
            {item.badge && (
              <div
                className={`ml-auto ${
                  item.badge === "Online"
                    ? "bg-white border border-[#d5d6d9] shadow-sm px-2 py-1 rounded-md text-xs"
                    : "bg-[#fafafa] border border-[#e9e9eb] px-2 rounded-full text-xs"
                }`}
              >
                {item.badge}
              </div>
            )}
          </div>
        </button>
      );
    }

    // Regular menu item (Link)
    return (
      <Link
        to={item.path}
        className={`flex items-center w-full px-3 py-2 rounded-lg transition-all duration-200 hover:bg-gray-100 ${
          location.pathname === item.path
            ? "bg-[#19BFB7] text-white"
            : "text-[#414651]"
        }`}
      >
        <div className="flex items-center gap-3 w-full">
          <div className="w-5 h-5 flex-shrink-0">
            {item.icon && (
              <img src={item.icon} alt="" className="w-full h-full" />
            )}
          </div>
          <span
            className={`font-semibold ${
              isOpen ? "opacity-100" : "opacity-0 md:opacity-100"
            } transition-opacity duration-200`}
          >
            {item.label || item.title}
          </span>
          {item.badge && (
            <div
              className={`ml-auto ${
                item.badge === "Online"
                  ? "bg-white border border-[#d5d6d9] shadow-sm px-2 py-1 rounded-md text-xs"
                  : "bg-[#fafafa] border border-[#e9e9eb] px-2 rounded-full text-xs"
              }`}
            >
              {item.badge}
            </div>
          )}
        </div>
      </Link>
    );
  };

  const renderMenuItems = () => {
    const items = menuItems[accountType] || [];
    return items.map((item, index) => (
      <div key={index}>
        {item.title && (
          <h3 className="px-3 mt-4 mb-2 text-xs font-semibold text-gray-500 uppercase">
            {item.title}
          </h3>
        )}
        {item.path && <MenuItem item={item} />}
        {item.links && item.links.map((link, linkIndex) => <MenuItem key={linkIndex} item={link} />)}
      </div>
    ));
  };

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="fixed top-4 left-4 z-50 p-2 bg-white rounded-md shadow-md md:hidden"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          {isOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      <div
        className={`md:sticky fixed top-0 left-0 h-screen bg-white border-r border-[#e9e9eb] transition-all duration-300 ease-in-out 
        
          ${isMobile && !isOpen ? "-translate-x-full" : "translate-x-0"}
          z-40`}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
{/* Logo */}
<div className="p-4 mb-6">
  <Link to="/" className="block">
    <img
      src={accountType === "linka" ? linkaLogo : "https://static.codia.ai/image/2025-03-15/80e47c7e-6309-4e3e-9c90-307a8aca0628.svg"}
      alt="Logo"
      className={`h-12 transition-all duration-300 ${
        isOpen ? "w-36" : "w-8"
      }`}
    />
  </Link>
</div>

          {/* Main Menu */}
          <div className="flex-1 px-2 space-y-1">{renderMenuItems()}</div>
          {/* Bottom Menu */}

        </div>
      </div>

      {/* Overlay for mobile */}
      {isMobile && isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={toggleSidebar}
        />
      )}
    </>
  );
};

export default Sidebar;